import { DatePickerChangeEvent, DatePicker } from "@progress/kendo-react-dateinputs"
import { FieldRenderProps } from "@progress/kendo-react-form"
import React from "react"

const EndOnDateComponent = (fieldRenderProps: FieldRenderProps) => {
    const {required, value, label, min, onChange} = fieldRenderProps

    const updateOnEndDate = (event: DatePickerChangeEvent) => {
        onChange(event)
    }

    return (
        <DatePicker
            label={label}
            value={value}
            width="200px"
            onChange={updateOnEndDate}
            min={min}
            required={required}
        />
    )
}


export default React.memo(EndOnDateComponent, (prevState, newState) => {
    return prevState.value === newState.value
})
